import {z} from 'zod';

export const RequestTireSetFormDefinitionSchema = z.object({
  requestBranchId: z.string(),
  neededAtDate: z.date(),
  neededAtTime: z.string(),
  note: z.string().nullish(),
});

export type RequestTireSetFormDefinition = z.infer<typeof RequestTireSetFormDefinitionSchema>;
